"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var helper_1 = require("../../utils/helper");
var theme_1 = require("../../utils/theme");
var Item = (function (_super) {
    tslib_1.__extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var _a = _this.props, onClick = _a.onClick, id = _a.id, disabled = _a.disabled;
            if (disabled) {
                return;
            }
            onClick(id);
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, description = _c.description, selected = _c.selected, title = _c.title, id = _c.id, disabled = _c.disabled, descriptionStyle = _c.descriptionStyle, titleStyle = _c.titleStyle, selectable = _c.selectable, titleClassName = _c.titleClassName, descriptionClassName = _c.descriptionClassName;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-selected"] = selected,
                _a[prefixCls + "-disabled"] = disabled,
                _a));
            var containerClasses = classNames(prefixCls + "-container", (_b = {},
                _b[prefixCls + "-container-with-desc"] = description,
                _b[prefixCls + "-container-selectable"] = selectable,
                _b));
            return (h("li", { className: classes, style: style, onClick: _this.handleClick },
                h("span", { className: containerClasses },
                    h("span", { className: classNames(prefixCls + "-title", titleClassName), style: titleStyle }, title || id),
                    description ?
                        h("span", { className: classNames(prefixCls + "-desc", descriptionClassName), style: descriptionStyle }, description)
                        : null)));
        };
        return _this;
    }
    Item.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Item;
}(React.Component));
exports.default = Item;
Item.defaultProps = {
    prefixCls: 'dui-m-actionsheet-item',
    onClick: helper_1.emptyFn,
    id: '',
    selected: false,
    disabled: false,
};
